import React from 'react'

export default function Contact() {
  return (
    <div className='section' id='contact'>
      <div className="border-solid border-black border-b pb-8 flex justify-between items-end gap-4 flex-wrap">
        <div>
          <div className="uppercase">Talk To Us</div>
          <div className="text-3xl font-bold">Table Reservations</div>
        </div>
        <div className="rounded-tr-[1rem] bg-[darkorange] text-white p-4 text-[0.85rem]">
          <a href="/#">Hurry & Get the Food still Hot</a>
        </div>
      </div>
    </div>
  )
}
 